import { call, put, select, takeEvery } from 'redux-saga/effects';
import uuid from 'uuid/v4';
import {
  duplicateScribeFailed,
  duplicateScribeStart,
  duplicateScribeSuccess,
  DUPLICATE_SCRIBE
} from 'JS/actionCreators/duplicateScribeActions';
import { showError } from 'JS/actionCreators/uiActions';
import { appServices } from 'JS/shared/helpers/app-services/AppServices';

import { getScribeById } from '../selectors';
import sanitizeScribeForTransport from '../sagaHelpers/sanitizeScribeForTransport';

export function* duplicateScribe({ scribeId, createdDate }) {
  const tempLoadingId = uuid();
  try {
    const originalScribe = yield select(getScribeById, scribeId);
    const newTitle = `${originalScribe.title} (copy)`;

    yield put(
      duplicateScribeStart({
        title: newTitle,
        createdOn: createdDate,
        updatedOn: createdDate,
        loadingId: tempLoadingId,
        status: 'loading'
      })
    );

    const plainScribe = sanitizeScribeForTransport(originalScribe, true);

    plainScribe.title = newTitle;
    plainScribe.createdOn = createdDate;
    plainScribe.updatedOn = createdDate;
    plainScribe.source = {
      type: 'duplicate',
      meta: {
        sourceScribeId: scribeId,
        sourceScribeSource: originalScribe.source?.type
      }
    };

    const newScribe = yield call(appServices.projects.createProject, plainScribe);
    yield put(duplicateScribeSuccess(newScribe, tempLoadingId));
  } catch (error) {
    yield put(duplicateScribeFailed(tempLoadingId));
    yield put(
      showError({
        message: `Duplicating Project ${scribeId} failed`,
        description: error.message
      })
    );
  }
}

export default function* duplicateScribeSagas() {
  yield takeEvery(DUPLICATE_SCRIBE, duplicateScribe);
}
